import { FC, ReactNode } from 'react';
import classnames from 'classnames';

import styles from './InputWrapper.scss';

type Props = {
    children: ReactNode;
    halfWidth?: boolean;
    useDisclaimerSpacing?: boolean;
};

const InputWrapper: FC<Props> = ({ children, halfWidth = false, useDisclaimerSpacing = false }) => {
    const style = classnames({
        [styles.halfInputWrapper]: halfWidth,
        [styles.inputWrapper]: !halfWidth,
        [styles.disclaimerSpacing]: useDisclaimerSpacing,
    });

    return <div className={style}>{children}</div>;
};

export default InputWrapper;
